import { __assign } from "tslib";
// DS: C16A
/** An editor content viewer for comments */
import React from 'react';
import BaseViewer from './Base';
import { useFlag } from '../../redux/flags/hooks';
import commentsTheme from '../Themes/Viewer/comments.scss';
import commentsThemeRedesignB from '../Themes/Viewer/comments.comment_redesign_b.scss';
import commentsThemeRedesignC from '../Themes/Viewer/comments.comment_redesign_c.scss';
var CommentViewer = function (props) {
    var isRedesignB = useFlag('comment_redesign_b');
    var isRedesignC = useFlag('comment_redesign_c');
    return (React.createElement("div", { className: 'da-editor-comments' },
        React.createElement(BaseViewer, __assign({ theme: isRedesignB
                ? commentsThemeRedesignB
                : isRedesignC
                    ? commentsThemeRedesignC
                    : commentsTheme, showMediaAlwaysSmall: true, fixedParagraph: false }, props))));
};
export default CommentViewer;
//# sourceMappingURL=Comment.js.map